<script setup>
import { computed, defineProps, onMounted } from "vue";
import CreateEditProgramSessions from "./components/CreateEditProgramSessions";
import Spinner from "@/components/helpers/Spinner.vue";
import { useStore } from "vuex";
import errorPage from "../../errorPage.vue";
import { channelTypes } from "@/components/program-manager/sessions/constants";
import { useTags } from "@/composables/useTags";

const { programSessionId } = defineProps({
  programSessionId: {
    type: String,
    required: true,
  },
});

const store = useStore();
const tags = useTags();

let channelId = Object.values(channelTypes).find(
  (val) => `${val}` === programSessionId
);
if (!channelId) {
  store.commit("programSessions/setProgramSession", undefined);
  store.dispatch("programSessions/fetchProgramSessionData", {
    programSessionId,
    skipCache: true,
  });
} else {
  store.commit("programSessions/setProgramSession", {});
}

const programSession = computed(() => {
  if (!channelId) {
    return store.getters["programSessions/getProgramSession"];
  }
  return undefined;
});

store.dispatch("programManager/fetchTerms");

const getLoadingProgramSession = computed(
  () => store.getters["programSessions/getLoadingProgramSession"]
);

const getLoadingProgramSessionUpdate = computed(
  () => store.getters["programSessions/getLoadingProgramSessionUpdate"]
);

const hasErrorMessage = computed(
  () => store.getters["programSessions/getProgramSessionErrorMessage"]
);

const hasErrored = computed(
  () => store.getters["programSessions/getProgramSessionError"]
);
</script>

<template>
  <!--  //TODO: This is just an example of how to use the VUE suspense. It will be removed later -->
  <!--  <Suspense>-->
  <!--    &lt;!&ndash; component with nested async dependencies &ndash;&gt;-->
  <!--    <template #default>-->
  <!--      <CreateEditProgramSessions :program-session-id="props.programSessionId" />-->
  <!--    </template>-->
  <!--    &lt;!&ndash; loading state via #fallback slot &ndash;&gt;-->
  <!--    <template #fallback>-->
  <!--      <Spinner-->
  <!--        class="m-auto w-full h-full !fixed opacity-75 bg-blue-100 !z-0"-->
  <!--      />-->
  <!--    </template>-->
  <!--  </Suspense>-->
  <CreateEditProgramSessions
    v-if="
      (programSession || channelId)
    "
    v-show="!getLoadingProgramSession && !getLoadingProgramSessionUpdate"
    :program-session-id="programSessionId"
    :channel-id="channelId"
    :program-session-orig="programSession"
    :tags="tags"
  />
  <errorPage
    v-else-if="
      !getLoadingProgramSession &&
      !getLoadingProgramSessionUpdate &&
      hasErrorMessage &&
      hasErrored
    "
  />
  <Spinner
    v-show="getLoadingProgramSession || getLoadingProgramSessionUpdate"
    class="m-auto w-full h-full !fixed opacity-75 bg-blue-100 !z-0"
  />
</template>
